var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue2-dropzone',{attrs:{"id":`file-uploader-${_vm.recordId}-${_vm.recordType}`,"options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.emitFileUpload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }